import React, { Component } from "react";
import axios from "axios";
import { Input, InputNumber, Select, Switch, Tooltip, Tag, Checkbox } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { ButtonItem, SelectInsumosItem } from "../../../../Components/Items";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";

const { Option } = Select;

let contador = 0;
const llave = () => `p${Date.now()}_${contador++}`;

const dinero = (v) => (v === null || v === undefined ? "" : `$${Number(v).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

// Refacciones y consumibles del servicio (controlado: value / onChange).
// Cada parte puede venir de Insumos (y descontar inventario de un almacen, guardando el
// costo real de la salida) o ser solo texto. Las que tienen lotes piden elegirlos.
class PartesServicio extends Component {
    state = { almacenes: [], existencias: {}, lotesDe: null };

    componentDidMount() {
        axios
            .post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
            .then((res) => this.setState({ almacenes: Array.isArray(res.data) ? res.data : [] }))
            .catch(() => {});
        (this.props.value || []).forEach((p) => p.descontarInventario && this.consultarExistencia(p));
    }

    lista = () => (this.props.value || []).map((p) => (p.key ? p : { ...p, key: p._id || llave() }));

    cambiar = (partes) => this.props.onChange && this.props.onChange(partes);

    actualizar = (i, cambios) => {
        const partes = this.lista().map((p, j) => (j === i ? { ...p, ...cambios } : p));
        this.cambiar(partes);
        const p = partes[i];
        if (("insumoId" in cambios || "proyectoId" in cambios || "descontarInventario" in cambios) && p.descontarInventario) this.consultarExistencia(p);
    };

    consultarExistencia = (p) => {
        if (!p.insumoId || !p.proyectoId) return;
        const clave = `${p.insumoId}_${p.proyectoId}`;
        axios
            .post("inventarios/inventarioInsumoProyecto", { proyectoId: p.proyectoId, insumoId: p.insumoId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
            .then((res) => this.setState((s) => ({ existencias: { ...s.existencias, [clave]: res.data?.cantidad ?? 0 } })))
            .catch(() => {});
    };

    agregar = () =>
        this.cambiar([
            ...this.lista(),
            { key: llave(), insumoId: null, insumo: null, descripcion: "", cantidad: 1, descontarInventario: false, proyectoId: this.state.almacenes.length === 1 ? this.state.almacenes[0]._id : null, motivoSustitucion: "", costoUnitario: null, fueraDeContrato: false, lotes: [] },
        ]);

    render() {
        const lista = this.lista();
        const { disabled, concluido } = this.props;
        return (
            <div>
                {lista.length > 0 && (
                    <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 980 }}>
                            <thead>
                                <tr style={{ background: "#eef2f6", fontSize: 12, textAlign: "left" }}>
                                    <th style={{ padding: 6, width: "30%" }}>Refacción o consumible</th>
                                    <th style={{ padding: 6, width: 80 }}>Cantidad</th>
                                    <th style={{ padding: 6, width: 220 }}>Inventario</th>
                                    <th style={{ padding: 6 }}>Motivo de sustitución</th>
                                    <th style={{ padding: 6, width: 120 }}>Costo unit.</th>
                                    <th style={{ padding: 6, width: 70 }}>Fuera de contrato</th>
                                    <th style={{ padding: 6, width: 40 }} />
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map((p, i) => {
                                    const existencia = this.state.existencias[`${p.insumoId}_${p.proyectoId}`];
                                    const conLotes = p.insumo?.lotesCaducidades;
                                    const lotesOk = !conLotes || (p.lotes || []).reduce((a, l) => a + Number(l.cantidadRequerida || 0), 0) === Number(p.cantidad || 0);
                                    return (
                                        <tr key={p.key} style={{ borderBottom: "1px solid #eef1f4", verticalAlign: "top" }}>
                                            <td style={{ padding: 6 }}>
                                                <SelectInsumosItem
                                                    empresaId={this.props.empresaId}
                                                    headersToken={this.props.headersToken}
                                                    placeholder="Buscar en Insumos (opcional)"
                                                    width="100%"
                                                    disabled={disabled}
                                                    value={p.insumoId || undefined}
                                                    insumoPreCargado={p.insumo || undefined}
                                                    onChange={(insumoId, insumo) =>
                                                        this.actualizar(i, {
                                                            insumoId: insumoId || null,
                                                            insumo: insumo || null,
                                                            descripcion: insumo?.descripcion || p.descripcion,
                                                            descontarInventario: !!insumo?.inventariable,
                                                            lotes: [],
                                                        })
                                                    }
                                                />
                                                <Input
                                                    size="small"
                                                    disabled={disabled}
                                                    placeholder="Descripción (como sale en la Orden de Servicio)"
                                                    value={p.descripcion}
                                                    onChange={(e) => this.actualizar(i, { descripcion: e.target.value })}
                                                    style={{ marginTop: 4 }}
                                                />
                                            </td>
                                            <td style={{ padding: 6 }}>
                                                <InputNumber min={0.0001} disabled={disabled} value={p.cantidad} onChange={(cantidad) => this.actualizar(i, { cantidad })} style={{ width: "100%" }} />
                                            </td>
                                            <td style={{ padding: 6 }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12 }}>
                                                    <Switch
                                                        size="small"
                                                        disabled={disabled || !p.insumoId}
                                                        checked={!!p.descontarInventario}
                                                        onChange={(descontarInventario) => this.actualizar(i, { descontarInventario })}
                                                    />
                                                    {p.descontarInventario ? "Descontar de almacén" : p.insumoId ? "No descontar" : "Sólo registro"}
                                                </div>
                                                {p.descontarInventario && (
                                                    <>
                                                        <Select
                                                            size="small"
                                                            disabled={disabled}
                                                            placeholder="Almacén"
                                                            value={p.proyectoId || undefined}
                                                            onChange={(proyectoId) => this.actualizar(i, { proyectoId, lotes: [] })}
                                                            style={{ width: "100%", marginTop: 4 }}
                                                        >
                                                            {this.state.almacenes.map((a) => (
                                                                <Option key={a._id} value={a._id}>
                                                                    {a.nombre}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                        {existencia !== undefined && !concluido && (
                                                            <div style={{ fontSize: 11, color: existencia >= Number(p.cantidad || 0) ? "#2e9e6b" : "#d64545" }}>Existencia: {existencia}</div>
                                                        )}
                                                        {conLotes && !disabled && (
                                                            <ButtonItem
                                                                type="link"
                                                                size="small"
                                                                htmlType="button"
                                                                disabled={!p.proyectoId}
                                                                onClick={() => this.setState({ lotesDe: i })}
                                                                style={{ padding: 0, color: lotesOk ? undefined : "#d64545" }}
                                                            >
                                                                {lotesOk ? "Lotes elegidos ✓" : "Elegir lotes"}
                                                            </ButtonItem>
                                                        )}
                                                    </>
                                                )}
                                            </td>
                                            <td style={{ padding: 6 }}>
                                                <Input.TextArea
                                                    autoSize={{ minRows: 1, maxRows: 3 }}
                                                    disabled={disabled}
                                                    placeholder="Ej. batería sin carga"
                                                    value={p.motivoSustitucion}
                                                    onChange={(e) => this.actualizar(i, { motivoSustitucion: e.target.value })}
                                                />
                                            </td>
                                            <td style={{ padding: 6 }}>
                                                {p.descontarInventario ? (
                                                    concluido ? (
                                                        <Tooltip title="Costo real de la salida de inventario">
                                                            <span>{dinero(p.costoUnitario)}</span>
                                                        </Tooltip>
                                                    ) : (
                                                        <Tag>Al concluir</Tag>
                                                    )
                                                ) : (
                                                    <InputNumber min={0} disabled={disabled} placeholder="Opcional" value={p.costoUnitario} onChange={(costoUnitario) => this.actualizar(i, { costoUnitario })} style={{ width: "100%" }} />
                                                )}
                                            </td>
                                            <td style={{ padding: 6, textAlign: "center" }}>
                                                <Checkbox disabled={disabled} checked={!!p.fueraDeContrato} onChange={(e) => this.actualizar(i, { fueraDeContrato: e.target.checked })} />
                                            </td>
                                            <td style={{ padding: 6 }}>
                                                {!disabled && <ButtonItem type="default" size="small" htmlType="button" rojo icon={<DeleteOutlined />} onClick={() => this.cambiar(lista.filter((_, j) => j !== i))} />}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                {!disabled && (
                    <ButtonItem type="dashed" htmlType="button" icon={<PlusOutlined />} onClick={this.agregar} style={{ marginTop: 8 }}>
                        Agregar refacción
                    </ButtonItem>
                )}
                {this.state.lotesDe !== null && lista[this.state.lotesDe] && (
                    <ElegirLotes
                        visible
                        insumoId={lista[this.state.lotesDe].insumoId}
                        proyectoId={lista[this.state.lotesDe].proyectoId}
                        cantidad={lista[this.state.lotesDe].cantidad}
                        lotes={lista[this.state.lotesDe].lotes || []}
                        cerrarElegirLotes={(lotes) => {
                            const i = this.state.lotesDe;
                            this.setState({ lotesDe: null });
                            if (Array.isArray(lotes)) this.actualizar(i, { lotes });
                        }}
                    />
                )}
            </div>
        );
    }
}

export default PartesServicio;
